import { X } from "lucide-react";
import CustomInput from "../../../shared/CustomInput";
import CustomSelect from "../../../shared/CustomSelect";
import Loading from "../../../shared/Loading";

const EditPersonalDetails = ({
  closeEditPersonalDetails,
  borrowerEditDetails,
  setBorrowerEditDetails,
  handleEditPersonalDetails,
  isLoadingPersonalDetails,
}) => {
  return (
    <div
      onClick={(e) => {
        closeEditPersonalDetails();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[550px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeEditPersonalDetails}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px]">
          Edit Personal Details
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-[20px]">
          Please fill in the personal information below to help us better
          understand your profile and serve you more effectively. All fields are
          required unless marked optional.
        </p>
        <div>
          <div className="flex flex-col gap-4">
            {/* Row 1: First, Middle, Last Name */}
            <div className="flex justify-between gap-4">
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="firstname"
                >
                  First Name
                </label>
                <CustomInput
                  placeholder="Enter your first name"
                  type="text"
                  value={borrowerEditDetails.firstname}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      firstname: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="middlename"
                >
                  Middle Name
                </label>
                <CustomInput
                  placeholder="Enter your middle name"
                  type="text"
                  value={borrowerEditDetails.middlename}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      middlename: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="lastname"
                >
                  Last Name
                </label>
                <CustomInput
                  placeholder="Enter your last name"
                  type="text"
                  value={borrowerEditDetails.lastname}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      lastname: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            {/* Row 2: ID Number, Gender, Phone Number */}
            <div className="flex justify-between gap-4">
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="idNumber"
                >
                  ID Number
                </label>
                <CustomInput
                  placeholder="Enter your ID number"
                  type="text"
                  value={borrowerEditDetails.identification}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      identification: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="gender"
                >
                  Gender
                </label>
                <CustomSelect
                  options={["male", "female"]}
                  placeholder="Select gender"
                  value={borrowerEditDetails.gender}
                  onChange={(value) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      gender: value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="phoneNumber"
                >
                  Phone Number
                </label>
                <CustomInput
                  placeholder="Enter your phone number"
                  type="text"
                  value={borrowerEditDetails.mobileno}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      mobileno: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            {/* Row 3: Alt Phone, Email, Marital Status */}
            <div className="flex justify-between gap-4">
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="altPhone"
                >
                  Alternate Phone Number
                </label>
                <CustomInput
                  placeholder="Enter alternate phone"
                  type="text"
                  value={borrowerEditDetails.altPhoneNumber}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      altPhoneNumber: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="email"
                >
                  Email
                </label>
                <CustomInput
                  placeholder="Enter your email"
                  type="email"
                  value={borrowerEditDetails.email}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      email: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="maritalStatus"
                >
                  Marital Status
                </label>
                <CustomSelect
                  options={["Single", "Married", "Divorced", "Widowed"]}
                  placeholder="Select marital status"
                  value={borrowerEditDetails.maritalStatus}
                  onChange={(value) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      maritalStatus: value,
                    })
                  }
                />
              </div>
            </div>

            {/* Row 4: Dependants, P.O. Box, Date of Birth */}
            <div className="flex justify-between gap-4">
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="dependants"
                >
                  Number of Dependants
                </label>
                <CustomInput
                  placeholder="Enter number of dependants"
                  type="number"
                  value={borrowerEditDetails.dependants}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      dependants: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="poBox"
                >
                  P.O. Box
                </label>
                <CustomInput
                  placeholder="Enter your P.O. Box"
                  type="text"
                  value={borrowerEditDetails.postal_address}
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      postal_address: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-[32%] flex flex-col">
                <label
                  className="text-[#222222] font-medium text-[13px]"
                  htmlFor="dob"
                >
                  Date of Birth
                </label>
                <CustomInput
                  placeholder="Select date of birth"
                  type="date"
                  value={
                    borrowerEditDetails.dob
                      ? borrowerEditDetails.dob.replace(/\//g, "-")
                      : ""
                  }
                  onChange={(e) =>
                    setBorrowerEditDetails({
                      ...borrowerEditDetails,
                      dob: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditPersonalDetails}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleEditPersonalDetails}
            disabled={isLoadingPersonalDetails}
            className="h-[35px] bg-[#000000] rounded-[30px] flex items-center justify-center gap-[5px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {isLoadingPersonalDetails && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPersonalDetails;
